<template>
  <div
    v-if="wizardText && !isHidden"
    class="card wizard-wrap"
    :style="{ background: wizardBg }"
  >
    <div class="wizard">
      <AuIcon
        class="icon"
        icon="alert"
      />

      <span
        v-if="wizardText.label"
      >
        {{ wizardText.label.text }}
        <RouterLink
          v-if="wizardText.link"
          :to="wizardText.link.link"
          class="link"
        >
          {{ wizardText.link.text }}
        </RouterLink>
      </span>

      <RouterLink
        v-if="wizardText.button"
        :to="wizardText.button.link"
        class="button"
      >
        {{ wizardText.button.text }}
      </RouterLink>
    </div>

    <div v-if="closable">
      <AuIcon
        clickable
        class="close-icon"
        icon="close"
        @click="hideWizard"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import wizardsController from "@/help/wizardsController";

export default {
  props: {
    texts: {
      type: Array,
      required: true
    },
    stage: {
      type: Number,
      default: 0
    },
    wizardName: {
      type: String,
      default: ""
    },
    closable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isHidden: false
    };
  },

  computed: {
    ...mapGetters({
      isLightTheme: "isLightTheme"
    }),

    wizardText() {
      return _.get(this.texts, `[${this.stage}]`, "");
    },

    wizardBg() {
      return _.get(this.texts, `[${this.stage}].verification`, {}) ? this.isLightTheme ? "#ffffff" : "#1c1c1e" : this.isLightTheme ? "#fcb7b7" : "#ff4848";
    }
  },

  created() {
    this.isHidden = wizardsController.checIskWizardHidden(this.$auth.user()?.id, this.wizardName) && this.closable;
  },

  methods: {
    hideWizard() {
      if (this.wizardName) {
        wizardsController.markWizardAsHidden(this.$auth.user()?.id, this.wizardName);
        this.isHidden = true;
      }
    }
  }
};
</script>

<style lang="scss">
.card {
  &.wizard-wrap {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    padding: 15px;
  }

  .wizard {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 20px;

    color: var(--text-color);

    line-height: 1.1;

    .link {
      text-decoration: underline !important;
      color: var(--text-color);
    }

    .button {
      background-color: #5ac396;
      color: #FFF;

      padding: 5px 10px;
      border-radius: 10px;

      white-space: nowrap;

      height: fit-content;
    }

    .icon {
      margin-right: -10px;
      height: 21px;
      width: 21px;
    }
  }

  .close-icon {
    height: 12px;
    width: 12px;

    min-height: 12px !important;
    min-width: 12px !important;

    padding: 0px !important;
  }
}
</style>